import React from 'react';
import { useNavigate } from 'react-router-dom';
import CheckIcon from '@mui/icons-material/Check';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import SpeakerNotesOffOutlinedIcon from '@mui/icons-material/SpeakerNotesOffOutlined';
import { useGuidedTour } from '../../../components/guided-tour/GuidedTourContext';
import { EXAMPLE_TOUR } from '../../../components/guided-tour/tourScripts';
import shell from '../SetupWizard.module.css';
import steps from './steps.module.css';
import local from './DoneScreen.module.css';
import styles from './ExampleScreens.module.css';

// Duas linhas do que a pessoa ganha e uma de segurança sobre os exemplos
const HIGHLIGHTS = [
  { icon: EventAvailableOutlinedIcon, title: 'Menos faltas', text: 'A confirmação fica pronta antes de cada horário; com o seu número conectado, sai sozinha.' },
  { icon: PaymentsOutlinedIcon, title: 'Pagamentos sem esquecer', text: 'Cada atendimento mostra o que já foi pago e o que falta receber.' },
  { icon: SpeakerNotesOffOutlinedIcon, title: 'Nada é enviado com os exemplos', text: 'Eles levam o selo Exemplo e saem com um clique pela faixa no topo.' },
];

// Contagens devolvidas por company/demo/seed.php, na ordem da tela
const COUNT_LABELS = [
  ['patients', 'pessoa', 'pessoas'],
  ['appointments', 'atendimento', 'atendimentos'],
  ['invoices', 'pagamento', 'pagamentos'],
  ['waiting_list', 'na lista de espera', 'na lista de espera'],
  ['leads', 'contato interessado', 'contatos interessados'],
  ['attachments', 'foto ou anexo', 'fotos e anexos'],
];

/**
 * "Pronto": fim da configuração de quem ganhou os exemplos. Diz o que foi criado
 * e fica parada até a pessoa clicar em "Começar agora", que abre o guia
 * "Conheça sua conta" (tourScripts, EXAMPLE_TOUR), que
 * mostra a conta preenchida e termina na faixa de remover. Depois a pessoa explora
 * livre; o guia dos Primeiros passos fica para depois de remover o exemplo.
 */
function ReadyScreen({ data, firstName }) {
  const tour = useGuidedTour();
  const navigate = useNavigate();
  const counts = data.example?.counts || {};
  const items = COUNT_LABELS.filter(([key]) => (counts[key] || 0) > 0)
    .map(([key, one, many]) => `${counts[key]} ${counts[key] === 1 ? one : many}`);

  return (
    <section className={`${shell.card} ${steps.done}`}>
      <span className={steps.doneIcon}><CheckIcon /></span>
      <h1 className={shell.title}>Pronto{firstName ? `, ${firstName}` : ''}! Tudo certo para você explorar</h1>
      <p className={steps.doneText}>
        Sua conta já tem uma rotina de exemplo, nos seus horários e com os seus preços. Vamos te guiar
        por alguns caminhos em poucos passos; depois é só explorar à vontade.
      </p>

      {items.length > 0 && (
        <ul className={`${steps.exampleCounts} ${styles.counts}`}>
          {items.map((text) => <li key={text}>{text}</li>)}
        </ul>
      )}

      <ul className={`${steps.exampleGuarantees} ${styles.guarantees}`}>
        {HIGHLIGHTS.map(({ icon: Icon, title, text }) => (
          <li key={title} className={steps.exampleGuarantee}>
            <span className={steps.segmentIcon}><Icon /></span>
            <strong className={steps.nextTitle}>{title}</strong>
            <span className={steps.nextText}>{text}</span>
          </li>
        ))}
      </ul>

      <div className={local.start}>
        <button type="button" className={`${shell.primaryButton} ${local.startButton}`} onClick={() => tour.start(EXAMPLE_TOUR)}>
          Começar agora
          <ArrowForwardIcon />
        </button>
        <span className={local.startHint}>Um guia rápido pelas telas, já com os exemplos.</span>
        <button type="button" className={shell.secondaryButton} onClick={() => navigate('/dashboard')}>
          Explorar por conta própria
        </button>
      </div>
    </section>
  );
}

export default ReadyScreen;
